// Strona produktu: galeria w wybranym kolorze, pasek do darmowej dostawy, pasek zakupu na telefonie
(() => {
  const fmt = (cents) => (cents / 100).toFixed(2).replace('.', ',') + ' zł';

  function parts(sectionId) {
    return {
      sectionId,
      selects: document.getElementById('variant-selects-' + sectionId),
      gallery: document.getElementById('MediaGallery-' + sectionId),
      sticky: document.getElementById('ValSticky-' + sectionId),
      ship: document.querySelector('#ProductInfo-' + sectionId + ' [data-val-ship]'),
      form: document.getElementById('product-form-' + sectionId),
    };
  }

  function variants(p) {
    if (p._variants) return p._variants;
    const json = p.selects && p.selects.querySelector('script[type="application/json"]');
    p._variants = json ? JSON.parse(json.textContent) : [];
    return p._variants;
  }

  function initialVariant(p) {
    const input = p.form && p.form.querySelector('input[name="id"]');
    const found = input && variants(p).find((v) => String(v.id) === input.value);
    if (found) return found;
    if (!p.sticky) return null;
    return { price: Number(p.sticky.dataset.price), available: p.sticky.dataset.available === 'true' };
  }

  function filterGallery(p, variant) {
    const g = p.gallery;
    if (!g || !g.dataset.valGroups || !variant || !variant.featured_media) return;
    const map = {};
    g.dataset.valGroups.split(',').forEach((pair) => {
      const [media, group] = pair.split(':');
      if (media) map[media] = group;
    });
    const group = map[variant.featured_media.id];
    if (!group) return;
    g.querySelectorAll('[data-media-id], [data-target]').forEach((el) => {
      const id = (el.dataset.mediaId || el.dataset.target || '').split('-').pop();
      if (id in map) el.classList.toggle('val-hide', map[id] !== group);
    });
    g.querySelectorAll('slider-component').forEach((slider) => {
      if (slider.slider) slider.slider.scrollTo({ left: 0 });
      if (typeof slider.resetPages === 'function') slider.resetPages();
    });
  }

  function updateShip(p, variant, cartOnly) {
    if (!p.ship) return;
    const threshold = Number(p.ship.dataset.threshold);
    const cart = Number(p.ship.dataset.cart);
    const total = cartOnly || !variant ? cart : cart + variant.price;
    const missing = threshold - total;
    const text = p.ship.querySelector('[data-val-ship-text]');
    const bar = p.ship.querySelector('[data-val-ship-bar]');
    if (cartOnly) {
      text.textContent = missing > 0 ? 'Do darmowej dostawy brakuje Ci ' + fmt(missing) : 'Masz darmową dostawę';
    } else {
      text.textContent =
        missing > 0
          ? 'Z tym produktem do darmowej dostawy zabraknie Ci ' + fmt(missing)
          : 'Z tym produktem masz darmową dostawę';
    }
    bar.style.width = Math.min(100, Math.floor((total * 100) / threshold)) + '%';
  }

  function updateSticky(p, variant) {
    const s = p.sticky;
    if (!s || !variant) return;
    const price = s.querySelector('[data-val-sticky-price]');
    const label = s.querySelector('[data-val-sticky-variant]');
    const btn = s.querySelector('[data-val-sticky-btn]');
    price.textContent = fmt(variant.price);
    if (label && variant.title) label.textContent = variant.title.split(' / ').join(' · ');
    const mainBtn = p.form && p.form.querySelector('.product-form__submit');
    btn.disabled = !variant.available;
    if (mainBtn) btn.textContent = mainBtn.textContent.trim();
  }

  function initSticky(p) {
    const s = p.sticky;
    const mainBtn = p.form && p.form.querySelector('.product-form__submit');
    if (!s || !mainBtn || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      s.classList.toggle('is-visible', show);
      s.inert = !show;
      document.body.classList.toggle('val-sticky-on', show);
    });
    observer.observe(mainBtn);
    const label = s.querySelector('[data-val-sticky-variant]');
    if (label && p.selects) {
      label.addEventListener('click', () => p.selects.scrollIntoView({ behavior: 'smooth', block: 'center' }));
    }
  }

  document.querySelectorAll('[data-val-pdp]').forEach((root) => {
    const p = parts(root.dataset.valPdp);
    const v = initialVariant(p);
    filterGallery(p, v);
    updateShip(p, v);
    updateSticky(p, v);
    initSticky(p);

    if (p.selects) {
      p.selects.addEventListener('change', () => {
        setTimeout(() => {
          const current = p.selects.currentVariant;
          if (!current) return;
          filterGallery(p, current);
          updateShip(p, current);
          updateSticky(p, current);
        }, 0);
      });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        fetch('/cart.js')
          .then((r) => r.json())
          .then((cart) => {
            if (!p.ship) return;
            p.ship.dataset.cart = cart.total_price;
            updateShip(p, null, true);
          })
          .catch(() => {});
      });
    }
  });
})();
